import { type FC } from 'react';

import { ArrowUpRight } from 'lucide-react';

import { QuoteForm } from '@features/request-quote';
import { COMPANY } from '@shared/config';
import { useAfterLoad } from '@shared/lib';

import styles from './ContactsPage.module.css';

const ContactsPage: FC = () => {
  // Виджет Яндекс Карт тянет мегабайты (Lighthouse 29.10.2026) и кешировать их нам не даёт —
  // вставляем его, когда сама страница загрузилась: форма и контакты отвечают сразу
  const afterLoad = useAfterLoad();

  return (
    <div className={styles.root}>
      <div className={styles.layout}>
        <div className={styles.left}>
          <div className={styles.badge}>Свяжитесь с нами</div>
          <h1 className={styles.pageTitle}>Контакты</h1>

          <div className={styles.contactLabel}>Телефон</div>
          <a className={styles.contactValue} href={COMPANY.phoneHref}>
            {COMPANY.phone}
          </a>

          <div className={styles.contactLabel}>Email</div>
          <a className={styles.contactValue} href={`mailto:${COMPANY.email}`}>
            {COMPANY.email}
          </a>

          <div className={styles.contactLabel}>Адрес производства</div>
          <div className={styles.contactValue} data-small="true">
            {COMPANY.address}
          </div>

          <div className={styles.map}>
            {afterLoad && (
              <iframe
                className={styles.mapFrame}
                src={COMPANY.mapEmbedUrl}
                title={`Адрес производства на Яндекс Картах: ${COMPANY.address}`}
                loading="lazy"
                referrerPolicy="no-referrer"
                allowFullScreen
              />
            )}
          </div>
          <a
            className={styles.mapLink}
            href={COMPANY.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Открыть в Яндекс Картах <ArrowUpRight aria-hidden />
          </a>
        </div>

        <div className={styles.right}>
          <QuoteForm />
        </div>
      </div>
    </div>
  );
};

export default ContactsPage;
